import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAllProjectSaveReport } from './projectReportService'

// Initial state definition
const initialState = {
    reports: [],
    isLoading: false,
    search: "",
    error: null,
    skip: 0,
    limit: 10,
    count: 0,
    isNext: false,
}

// Async thunk to fetch candidates
export const getAllProjectReport = createAsyncThunk(
    'projectReportSlice/list',
    async (data) => {
        const response = await getAllProjectSaveReport(data)
        return response
    }
)
// Slice definition
export const projectReportSlice = createSlice({
    name: 'projectReportSlice',
    initialState,
    reducers: {
        setSearch: (state, action) => {
            state.search = action.payload
            state.skip = 0;
        },
        setSkip: (state, action) => {

            state.skip = action.payload;
        },
        setLimit: (state, action) => {
            state.limit = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllProjectReport.pending, (state) => {
                state.isLoading = true
            })

            .addCase(getAllProjectReport.fulfilled, (state, action) => {
                state.reports = action.payload.data || []
                state.isNext = action.payload?.isNext || false;
                state.count = action.payload?.count || 0;
                state.isLoading = false
                state.error = null

            })
            .addCase(getAllProjectReport.rejected, (state, action) => {
                state.reports = []
                state.isLoading = false
                state.error = action.payload
            })

    },
})

export default projectReportSlice.reducer

// Export actions (if any)
export const { setSearch, setSkip, setLimit } = projectReportSlice.actions
